import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Link, Grid, Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

import CloudinaryImage from '../../../cloudinary-media/image'

export const ImageLink = ({
    primaryImage,
    secondaryImage,
    imageAlt,
    title,
    titleColor = 'black',
    titleTag = 'p',
    titleFontFamily,
    cardBackground = 'black.300',
    url,
    titleFontSize,
    titleFontWeight,
    eagerLoadImage
}) => {
    const [isHover, setIsHover] = useState(false)
    const [isTouchDevice, setIsTouchDevice] = useState(false)

    useEffect(() => {
        const checkTouchDevice = () => {
            return (
                'ontouchstart' in window ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0
            )
        }
        setIsTouchDevice(checkTouchDevice())
    }, [])

    if (!primaryImage) {
        return null
    }

    const handleMouseEnter = () => {
        setIsHover(true)
    }

    const handleMouseLeave = () => {
        setIsHover(false)
    }

    return (
        <Link
            href={url}
            onMouseOver={!isTouchDevice ? handleMouseEnter : undefined}
            onMouseLeave={!isTouchDevice ? handleMouseLeave : undefined}
            display="block"
            width="200px"
            overflow="hidden"
            flexShrink="0"
            borderRadius="3px"
            _hover={{textDecoration: 'none'}}
        >
            <Grid>
                <Box gridArea="1 /1">
                    <CloudinaryImage
                        src={primaryImage}
                        alt={imageAlt || title || ''}
                        aspectRatio="200:162"
                        imgSizes={{
                            base: '200px'
                        }}
                        sizes={[200]}
                        styles={{
                            opacity: isHover && secondaryImage ? 0 : 1,
                            transition: 'opacity 0.3s ease-in-out',
                            aspectRatio: '200 / 162',
                            width: '100%',
                            height: 'auto',
                            htmlWidth: 200,
                            htmlHeight: 162
                        }}
                        lazyload={!eagerLoadImage}
                    />
                </Box>

                {secondaryImage && (
                    <Box gridArea="1 /1">
                        <CloudinaryImage
                            src={secondaryImage}
                            alt={imageAlt || title || ''}
                            aspectRatio="200:162"
                            imgSizes={{
                                base: '200px'
                            }}
                            sizes={[200]}
                            styles={{
                                opacity: isHover ? 1 : 0,
                                transition: 'opacity 0.3s ease-in-out',
                                aspectRatio: '200 / 162',
                                width: '100%',
                                height: 'auto',
                                htmlWidth: 200,
                                htmlHeight: 162
                            }}
                        />
                    </Box>
                )}
            </Grid>

            {title && (
                <Text
                    as={titleTag}
                    backgroundColor={cardBackground}
                    textStyle="h8"
                    color={titleColor}
                    padding="10px"
                    fontSize={titleFontSize}
                    fontWeight={titleFontWeight}
                    fontFamily={titleFontFamily || 'body'}
                    css={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    {title}
                </Text>
            )}
        </Link>
    )
}

ImageLink.propTypes = {
    primaryImage: PropTypes.string,
    secondaryImage: PropTypes.string,
    imageAlt: PropTypes.string,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    titleTag: PropTypes.string,
    titleFontFamily: PropTypes.string,
    cardBackground: PropTypes.string,
    url: PropTypes.string,
    titleFontSize: PropTypes.string,
    titleFontWeight: PropTypes.string,
    eagerLoadImage: PropTypes.bool
}

export default ImageLink
